import { createContext } from 'react';

export const popupContext = createContext({
  showPopup: false,
  toggleShowPopup: () => {}
});
